import { makeStyles } from "tss-react/mui";
const TEXT_MIN_CONTAINER_WIDTH = 150;
const RETRY_TEXT_MIN_CONTAINER_WIDTH = 300;
const useStyles = makeStyles()(({ containerQueries, tokens })=>({
        root: {
            containerType: 'inline-size',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            maxWidth: '100%',
            minWidth: 0,
            border: `${tokens.border.s}px solid ${tokens.colors.stroke.primary}`,
            backgroundColor: tokens.colors.bg.greyscale.primary
        },
        withContent: {
            gap: tokens.spacing['8'],
            padding: tokens.spacing['16'],
            [containerQueries.down(TEXT_MIN_CONTAINER_WIDTH)]: {
                gap: 0,
                padding: 0
            }
        },
        icon: {
            flexShrink: 0,
            [containerQueries.down(TEXT_MIN_CONTAINER_WIDTH)]: {
                width: `${tokens.spacing['20']}px !important`,
                height: `${tokens.spacing['20']}px !important`
            }
        },
        text: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            minWidth: 0,
            [containerQueries.down(TEXT_MIN_CONTAINER_WIDTH)]: {
                display: 'none'
            }
        },
        secondaryText: {
            [containerQueries.down(RETRY_TEXT_MIN_CONTAINER_WIDTH)]: {
                display: 'none'
            }
        }
    }));
export { useStyles };
